import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'
import { Observable } from 'rxjs'

@Component({
  selector: 'basin-formly-radio-button',
  templateUrl: './formly-radio-button.component.html',
  styleUrls: ['./formly-radio-button.component.scss'],
})
export class FormlyRadioButtonComponent extends FieldType {
  checkIfObservable(options: Observable<any[]> | any[]) {
    return options instanceof Observable
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.stopPropagation()
    }
  }
}
